export interface ReconnectPolicyConfig {
  maxAttempts: number;
  baseDelayMs: number;
  maxDelayMs: number;
  jitterRatio: number;
}

export interface ReconnectSchedule {
  attempt: number;
  shouldRetry: boolean;
  delayMs: number;
}

export const DEFAULT_RECONNECT_POLICY: ReconnectPolicyConfig = {
  maxAttempts: 8,
  baseDelayMs: 1000,
  maxDelayMs: 8000,
  jitterRatio: 0.25,
};

export const computeReconnectSchedule = (
  attempt: number,
  config: ReconnectPolicyConfig = DEFAULT_RECONNECT_POLICY,
): ReconnectSchedule => {
  if (attempt > config.maxAttempts) {
    return { attempt, shouldRetry: false, delayMs: 0 };
  }
  const capped = Math.min(config.maxDelayMs, config.baseDelayMs * (2 ** (attempt - 1)));
  const jitterRange = Math.floor(capped * config.jitterRatio);
  const jitter = jitterRange > 0 ? Math.floor((Math.random() * ((jitterRange * 2) + 1)) - jitterRange) : 0;
  return {
    attempt,
    shouldRetry: true,
    delayMs: Math.max(0, capped + jitter),
  };
};
